import { useEffect, useState } from "react";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { Suppliers } from "../../profile/Suppliers";
import { Growers } from "../../profile/Growers";

export const SettingsGrowers = () => {

  const { growers } = useTypedSelector(state => state.auth);

  const [active, setActive] = useState<number>(0)

  useEffect(() => {
    if( growers.length > 1 ){
      setActive(1)
    }
  }, [growers])
  

  return (
    <div>
      <h3 className="tw-mb-4">Growers</h3>
      <div className="flex flex-gap border-b pb-1 mb-1 suppliers-btns">
        {
          growers.length > 0 &&
          growers.map((grower, index) => (
            <button
              key={grower.id}
              onClick={() => setActive(index)}
              className={`supplier-btn ${active === index ? "active" : ""} flex flex-gap`}>
              {grower.name}
              <div className={`supplier-count font-xsmall ${active === index && "active"}`}>{grower.growers.length}</div>
            </button>
          ))
        }
      </div>

      {
        growers[active] &&
        <Growers growersList={growers[active]} />
      }
    </div>
  )
}
